import React from 'react';

import { DateRange, DayPickerProps, PropsBase, PropsRangeRequired } from 'react-day-picker';

import { IDatesRange } from 'detailsv2/structure';

import { formatDate, parseDate, parseDateRange } from './functions';

type TSinglePicker = PropsBase & {
  mode: 'single';
  selected?: string | null;
  onSelect: (date?: string | null) => void;
};

type TRangePicker = PropsBase & {
  selected?: IDatesRange | null;
  onSelect: (range?: IDatesRange) => void;
} & Omit<PropsRangeRequired, 'selected' | 'onSelect' | 'required'>;

export const withDateResolver = (WrappedComponent: React.ComponentType<DayPickerProps>) => {
  return (props: TSinglePicker | TRangePicker) => {
    if (props.mode === 'range') {
      const selected = parseDateRange(props.selected);
      const onSelect = (dateRange?: DateRange) => {
        props.onSelect({ start: formatDate(dateRange?.from), end: formatDate(dateRange?.to) });
      };

      return (
        <WrappedComponent
          {...props}
          defaultMonth={selected.from ?? props.defaultMonth}
          selected={selected}
          onSelect={onSelect}
        />
      );
    }

    const selected = parseDate(props.selected);
    const onSelect = (date?: Date) => props.onSelect(formatDate(date));
    return (
      <WrappedComponent
        {...props}
        defaultMonth={selected ?? props.defaultMonth}
        selected={selected}
        onSelect={onSelect}
      />
    );
  };
};
